import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Environment, FunzioniGruppi, FunzioniModelli, ModelNumStr } from '../../models/-index';
import { CrudGenericsService } from '../common/crud-generics';
import { Observable } from 'rxjs';

@Injectable()
export class FunzioniGruppiService extends CrudGenericsService<FunzioniGruppi, number> {
  private base: string;

  constructor(protected http: HttpClient, @Inject('ENV') env: Environment) {
    super(http, `${env.apiUrl}/api/FunzioniGruppi`);
    this.base = `${env.apiUrl}/api/FunzioniGruppi/`;
  }
  GetAll_ByAzb(azb: number) {
    const u = `${this.base}GetAll_ByAzb?azb=${azb}`;
    return this.http.get<FunzioniGruppi[]>(u);
  }
  Clone_FunzGruppi(new_item: FunzioniGruppi, from_id: number): Observable<any> | Observable<ModelNumStr> {
    const u = `${this.base}Clone_FunzGruppi/${from_id}`;
    return this.http.post<FunzioniGruppi>(u, new_item);
  }
  SaveAs_FunzModello(fm: FunzioniModelli[], new_name: string) {
    const u = `${this.base}SaveAs_FunzModello?new_name=${new_name}`;
    return this.http.post<FunzioniModelli[]>(u, fm);
  }
  Get_NonEliminabile_FunzGruppi() {
    const u = `${this.base}Get_NonEliminabile_FunzGruppi`;
    return this.http.get<FunzioniGruppi[]>(u);
  }
}
